// packages block
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import {
  TableRow,
  Checkbox,
  TableCell,
  Avatar,
  Typography,
  makeStyles,
} from "@material-ui/core";
// common block
import { FormSelect } from "../../form";
// constants, theme, utils and api block
import { editUser } from "../../../api/users";
import { BASE_IMG } from "../../../util/constants";
import { setAlert } from "../../../redux/reducers/alert";
import { BLUE_EIGHT, GRAY_THIRTEEN } from "../../../theme";
import { setStatus } from "../../../redux/reducers/status";
import { setRole } from "../../../redux/reducers/role";
import CustomCheckbox from "../../customCheckbox";
import { Dropdown } from "../userRow/Dropdown";
import { capitalizeFirstLetter } from "../../../util/stringManipulation";

const useStyles = makeStyles({
  customTable: {
    "& .MuiTableCell-alignLeft": {
      // padding: "22px 0px 22px 0px",
    },
  },
});

export const UserRow = ({
  isItemSelected,
  handleClick,
  selectionKey,
  row,
  columns,
  openActionMenu,
  actionButtonClass,
  labelId,
  fetchUsers,
}) => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.user);

  const firstName = capitalizeFirstLetter(row["firstName"] ?? "");
  const lastName = capitalizeFirstLetter(row["lastName"] ?? "");

  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };
  const updateUser = async (data) => {
    try {
      const response = await editUser(data, row["id"], token);
      if (!response.status)
        showErrorAlert(response?.message || "Error in updating user");
    } catch (err) {
      showErrorAlert(err.message || "Error in updating user");
    }
    await fetchUsers();
  };

  const handleChange = (prop) => (event) => {
    if (prop === "role") {
      updateUser({ role: event.target.value });
      dispatch(setRole({ role: event.target.value }));
    }

    if (prop === "status") {
      updateUser({ status: event.target.value === 1 ? 1 : 0 });
      dispatch(setStatus({ status: event.target.value === 1 ? 1 : 0 }));
    }
  };

  const user = useSelector((state) => state.user);
  return (
    <>
      {row["id"] !== user.id ? (
        <TableRow
          hover
          style={{
            borderBottom: "1px solid lightgray",
            backgroundColor: isItemSelected ? "#FAF9F6" : "white",
          }}
          role="checkbox"
          aria-checked={isItemSelected}
          tabIndex={-1}
          key={row.name}
          selected={isItemSelected}
          classes={{ root: classes.customTable }}
        >
          <TableCell padding="checkbox">
            <CustomCheckbox
              onClick={(event) => handleClick(event, row[selectionKey])}
              checked={isItemSelected}
              inputProps={{ "aria-labelledby": labelId }}
            />
          </TableCell>

          <TableCell
            align="left"
            style={{ display: "flex", alignItems: "center", border: "none" }}
          >
            <Avatar
              src={
                row["file"] != null && row["file"] != "null"
                  ? BASE_IMG + row["file"]
                  : ""
              }
              style={{
                height: 40,
                width: 40,
                marginRight: 10,
                backgroundColor: "#006E7D",
              }}
            />

            <div style={{ display: "flex", flexDirection: "column" }}>
              <Typography
                variant="body2"
                style={{ color: GRAY_THIRTEEN, fontSize: "0.55vw" }}
              >
                User Name
              </Typography>
              <Typography
                variant="h5"
                style={{
                  color: BLUE_EIGHT,
                  fontSize: "0.7vw",
                  fontWeight: "bold",
                }}
              >{`${firstName} ${lastName}`}</Typography>
              {/* <div style={{ fontSize: 12, color: "gray" }}>{row["email"]}</div> */}
            </div>
          </TableCell>

          <TableCell align="left">
            <Dropdown
              disabled={user.role === "readOnly" ? true : false}
              error={false}
              list={[
                {
                  value: 1,
                  label: "Active",
                },
                {
                  value: 0,
                  label: "In Active",
                },
              ]}
              value={Boolean(row.status) ? 1 : 0}
              name="status"
              onChange={handleChange}
            />
          </TableCell>

          <TableCell align="left">
            <Dropdown
              disabled={user.role === "readOnly" ? true : false}
              error={false}
              list={[
                {
                  value: "manager",
                  label: "Manager",
                },
                {
                  value: "readOnly",
                  label: "Read-Only",
                },
                {
                  value: "paymentOnly",
                  label: "Payment Only",
                },
              ]}
              value={row.role}
              name="role"
              onChange={handleChange}
            />
          </TableCell>

          <TableCell
            align="left"
            hidden={user.role === "readOnly" ? true : false}
          >
            <div
              role="presentation"
              onClick={(e) => {
                openActionMenu(e, row);
              }}
              className={actionButtonClass}
            >
              <MoreHorizIcon />
            </div>
          </TableCell>
        </TableRow>
      ) : (
        <></>
      )}
    </>
  );
};
